import dom from '../../../wrapper/DomWrapper';

import {
  ALT,
  HOST,
  GUID,
} from '../constants';

export default (imageURL) => `${HOST}?url=${dom.document.URL}&guid=${GUID}&media=${imageURL}&description=${ALT}`;
